import { render, staticRenderFns } from "./AppraisalSupervisorReviewTable.vue?vue&type=template&id=571c62e5"
import script from "./AppraisalSupervisorReviewTable.vue?vue&type=script&lang=js"
export * from "./AppraisalSupervisorReviewTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports